import { Upload } from 'antd'
import styled from 'styled-components'

export const DraggerStyled = styled(Upload.Dragger)`
  width: 100% !important;
  padding: 10px !important;
  height: 150px !important;
  margin-bottom: 20px !important;
`